import { Theme } from '@mui/material';
/**
 * @example styles for toast component
 */
const CcfAppToastMessageStyles = (theme: Theme) => {
  const styles = {
    toastMessage: {
      '.text,.titleText,.subMessageText': {
        color: '#333333',
        marginLeft: '10px',
        marginBottom: '10px',
        marginRight: '10px',
      },
      '.confimationBtn button': {
        marginRight: '30px',
        width: '90px',
        fontSize: '14px',
        padding: '8px',
      },
      '.text h5': {
        fontWeight: 'bold',
        fontSize: '0.9rem',
      },
    },
    text: {
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },
    logoutConfirmationPanel: {
      [theme.breakpoints.down('xl')]: {
        display: 'flex',
      },
    },
    subText: {
      color: theme.palette.text.primary,
    },
    secondaryButton: {
      float: 'right',
    },
    primaryBtn: {
      left: '30%',
    },
  };
  return styles;
};

export default CcfAppToastMessageStyles;
